<template>
  <mep-carousel :card-variant :slides="[Ref1, Ref2, Ref3, Ref4, Ref5]" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

withDefaults(
  defineProps<{
    cardVariant?: 'inline' | 'modal';
  }>(),
  {
    cardVariant: 'modal',
  }
);

const Ref1 = defineAsyncComponent(() => import('./MepRef14.1.vue'));
const Ref2 = defineAsyncComponent(() => import('./MepRef14.2.vue'));
const Ref3 = defineAsyncComponent(() => import('./MepRef14.3.vue'));
const Ref4 = defineAsyncComponent(() => import('./MepRef14.4.vue'));
const Ref5 = defineAsyncComponent(() => import('./MepRef14.5.vue'));
</script>
